import React from 'react';
import { Box, Grid, Typography } from '@mui/material/';
import Image from 'next/image';
// src
import ArrowBottomRight from '../../icons/ArrowBottomRight';
// styles
import styles from './styles';

export interface LibFoxtonsAwardsListProps {
  cardsContent: Array<{
    image: {
      src: string;
      altImg: string;
    };
    title: string;
    subtitle: string;
    year: string;
    href: string;
    handleClickCard?: () => void;
    id?: string;
  }>;
  cardsPerRow?: number;
  title: string;
}

export interface LibAwardsCardProps {
  title: string;
  subtitle: string;
  year: string;
  href: string;
  img: {
    src: string;
    alt: string;
  };
}

function truncateString(str: string, maxLength: number) {
  if (str.length <= maxLength) {
    return str;
  }

  return `${str.slice(0, maxLength - 3)}...`;
}

function AwardsCard({ title, subtitle, year, img, href }: LibAwardsCardProps) {
  const titleMaxChars = 65;
  const subtitleMaxChars = 40;

  let titleDisplay = '';
  let subtitleDisplay = '';

  if (title?.length > titleMaxChars) {
    titleDisplay = truncateString(title, titleMaxChars);
  } else {
    titleDisplay = title;
  }

  if (subtitle?.length > subtitleMaxChars && title?.length > subtitleMaxChars) {
    subtitleDisplay = truncateString(subtitle, subtitleMaxChars);
  } else {
    subtitleDisplay = subtitle;
  }

  return (
    <Box sx={styles.card} component="a" href={`/foxtons/awards/${href}`}>
      <Box sx={styles.cardImg}>
        <Image
          src={img.src}
          fill
          objectFit="contain"
          objectPosition="center"
          style={{ position: 'absolute' }}
          alt={img.alt}
          unoptimized
        />
      </Box>
      <Box sx={styles.content} className="content">
        <Box sx={styles.title} className="title">
          <Typography variant="subtitle2">{titleDisplay}</Typography>
        </Box>
        <Box sx={styles.subtitle} className="subtitle">
          <Typography variant="body1">{subtitleDisplay}</Typography>
        </Box>
        <Box sx={styles.year} className="year">
          <Typography variant="body1">{year}</Typography>
        </Box>
        <Box sx={styles.bottomIcon} className="BottomIconClass">
          <ArrowBottomRight sx={styles.arrowIcon} className="arrowIcon" />
        </Box>
      </Box>
    </Box>
  );
}

function LibFoxtonsAwardsList({
  title,
  cardsContent,
  cardsPerRow = 3
}: LibFoxtonsAwardsListProps) {
  return (
    <Box sx={styles.mainContainer} component="section">
      <Box sx={styles.contentContainer}>
        <Typography variant="h2" sx={styles.headingTitle}>
          {title}
        </Typography>

        <Grid container spacing={1}>
          {cardsContent?.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={12 / cardsPerRow}
              xl={12 / (cardsPerRow + 1)}
              key={item.id}
            >
              <AwardsCard
                title={item.title}
                subtitle={item.subtitle}
                year={item.year}
                img={{
                  src: item?.image?.src || '',
                  alt: item?.image?.altImg || 'alt-img'
                }}
                href={item.href}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export const FoxtonsAwardsList = React.memo(LibFoxtonsAwardsList);

export default FoxtonsAwardsList;
